export const cfaDarkThemeBuiCss = `
:root, body[data-theme-mode='dark'] {
  --cfa-font-size-base: 14px;
  --bui-font-size-1: 1.3rem;
  --bui-font-size-2: 1rem;
  --bui-font-size-3: 0.95rem;
  --bui-font-regular: Apercu;
  --bui-font-weight-regular: 400;
  --bui-font-weight-bold: 700;
  --bui-black: #000;
  --bui-white: #fff;
  --bui-fg-primary: #ebebebff;
  --bui-fg-secondary: #CCCCCC;
  --bui-fg-disabled: #93989bff;
  --bui-fg-solid: #ffffffff;
  --bui-fg-solid-disabled: #93989bff;
  --bui-fg-danger: #c53959ff;
  --bui-fg-warning: #fcd560ff;
  --bui-fg-success: #59a987ff;
  --bui-fg-info: #3389aeff;
  --bui-fg-danger-on-bg: rgba(137, 39, 62, 1);
  --bui-fg-warning-on-bg: rgba(176, 149, 67, 1);
  --bui-fg-success-on-bg: rgba(62, 118, 94, 1);
  --bui-fg-info-on-bg: rgba(35, 95, 121, 1);
  --bui-bg-app: #1e272fff;
  --bui-bg-neutral-1: #37424aff;
  --bui-bg-neutral-2: #1e272fff;
  --bui-bg-neutral-3: #1e272fff;
  --bui-bg-solid: #5DADE2;
  --bui-bg-solid-hover: rgb(79, 147, 192);
  --bui-bg-solid-pressed: rgb(65, 121, 158);
  --bui-bg-solid-disabled: rgba(255, 255, 255, 0.12);
  --bui-bg-danger: rgba(208, 96, 122, 1);
  --bui-bg-warning: rgba(252, 221, 127, 1);
  --bui-bg-success: rgba(122, 186, 159, 1);
  --bui-bg-info: rgba(91, 160, 190, 1);
  --bui-border-danger: #c53959ff;
  --bui-border-warning: #fcd560ff;
  --bui-border-success: #59a987ff;
  --bui-border-info: #3389aeff;
  --bui-border-2: #37424aff;
  --bui-ring: #FFFBCC;
  .bui-PluginHeader {
    display: none;
  }
  .bui-PluginHeaderToolbarWrapper {
    border-bottom: none;
  }
}`;